// Microformats

// h-product — a simple, open format for publishing product data on the web. h-product is one of several open microformat draft standards suitable for embedding data in HTML.
// See http://microformats.org/wiki/h-product

export enum HCard {
  VCard = "v-card",
  Name = "fn",
  Company = "org",
  Photo = "photo",
  URL = "url",
  Email = "email",
  Tel = "tel",
  Bio = "note",
}
